import styles from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  message?: string;
}

const TranscriptError: FC<Props> = ({ message }) => {
  if (!message) {
    return null;
  }

  return <div className={styles['transcript-error']}>{message}</div>;
};

export default TranscriptError;
